module.exports = {
   Kenya: require('./kenya'),
}